import React, { type ComponentPropsWithoutRef } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AvatarItem = (props: ComponentPropsWithoutRef<any>): React.JSX.Element => (
	<AvatarItemComponent {...props} />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LocationName = (props: ComponentPropsWithoutRef<any>): React.JSX.Element => (
	<LocationNameComponent {...props} />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FieldWrapper = (props: ComponentPropsWithoutRef<any>): React.JSX.Element => (
	<FieldWrapperComponent {...props} />
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LocationNameComponent = styled.div({
	marginLeft: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AvatarItemComponent = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FieldWrapperComponent = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > div': {
		marginTop: token('space.250'),
	},
});
